import React, { Component } from 'react';
import $ from 'jquery';
import jQuery from 'jquery';

import AdminLayout from './layout';

import FetchCall from '../../API/FetchCall';

//import { Editor } from '@tinymce/tinymce-react';
import { sendRegretNoData,  getPartnerLeadInfo, checkpushLead, getMailInfo, confirmLead, createLeadManual, bringNoDateMail} from '../../API/FetchCall';

import { EditorState, convertToRaw, convertFromHTML, convertFromRaw, ContentState } from 'draft-js';
//import { Editor } from 'react-draft-wysiwyg';
import '../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';

import { Editor } from '@tinymce/tinymce-react';
import { TINY_EDITOR } from '../../constant';

import axios from 'axios';

class leadDetail extends Component {

     constructor(props) {
        super(props);
        
        this.state = {
            lead:"",
            openModal:false,
            checkMailContent:false,
            fetchedPartnerListHTML:'',
            lead_data:[],
            maillist:[],
            partnerlist:[],
            manualpartnerlist:[],
            partners_f:[],
            created_date:"",
            confirmnodataregret:false,
            distance:'',
            modetype:'',
            auth_data: JSON.parse(localStorage.getItem("user_data")),
            user_data: localStorage.getItem('user_data') ? JSON.parse(localStorage.getItem('user_data')) : [],
            authentication: localStorage.getItem('authentication') ? JSON.parse(localStorage.getItem('authentication')) : false,
        }
           
        this.lead_id = this.props.match.params.id ? this.props.match.params.id : '';
        if (this.lead_id !== undefined) {
            
            this.leadDetail(this.lead_id);
            this.partnerLeadInfo(this.lead_id);

        }
        this.renderUsers = this.renderUsers.bind(this);
        this.leadDetail = this.leadDetail.bind(this);
        this.getMailinfo = this.getMailinfo.bind(this);
        this.domanualprocess = this.domanualprocess.bind(this);
        this.handleEditorChange = this.handleEditorChange.bind(this);
        this.confirmPush = this.confirmPush.bind(this);
        this.doregretprocess = this.doregretprocess.bind(this);

    }
    
    handleChange = (e) => {
      this.setState({ [e.target.name]: e.target.value });
    };
  
    doregretprocess (lead_id){

      let req = JSON.stringify({
        lead_id:lead_id,
        firstname: this.state.firstname,
        lastname: this.state.lastname,
        email:this.state.email
      });
      
      bringNoDateMail(req).then((response) => {
        if (response.status === 1) {

          this.setState({loading:false, regret_mailcontent: response.mail_content, confirmnodataregret:true});

        }

      })

    }


    confirmRegretSend(lead_id){


      let req = JSON.stringify({
        lead_id:lead_id,
        mail_content:this.state.mail_content,
        email:this.state.email 
    });

    sendRegretNoData(req).then((response) => {
      if (response.status === 1) {
        
        alert("mail is sent");

      }
      else{
        alert("mail is not sent");

      }
    });

    }
     

    domanualprocess(lead_id){

      $("#responsemessage").html("");
     
      let req = JSON.stringify({
        lead_id:lead_id,
        distance:this.state.distance,
        type:this.state.modetype
      });

      checkpushLead(req).then((response) => {
        if (response.status === 1) {
          
          $("#manualbtnsection").addClass('hidden');

          if(response.manualpartnerlist.length>0){
          this.setState({
            manualpartnerlist:response.manualpartnerlist,
            mail_content:response.mail_content,
            partners_f:response.manualpartnerlist,
            openModal: true
          })
          }else{
            $("#responsemessage").html("No partners found..");

          }
   

        }
        else{
          $("#manualbtnsection").removeClass('hidden');
           this.setState({
            openModal: false
          })
    
        }
      });
    }

    confirmPush(){


      let req = JSON.stringify({
        lead_id:this.props.match.params.id,
        distance:this.state.distance,
        type:this.state.modetype
      });
      this.setState({loading:true});
      confirmLead(req).then((response) => {
        if (response.status === 1) {
          
          $("#manualcreatlead").addClass('hidden');
          this.setState({
            loading:false,
            checkMailContent: true
          })
   

        }
        else{
          
           this.setState({
            loading:false,
            checkMailContent: false
          })
    
        }
      });

    }


    async getMailinfo() {


        let req = JSON.stringify({
            lead_id: this.lead_id
        });

        $("#showmailinfoBtn").addClass('hidden');

        getMailInfo(req).then((response) => {
          if (response.status === 1) {
            this.setState({
                maillist: response.list
            })
          }else{

            $("#showmailinfoBtn").removeClass('hidden');
            this.setState({
                maillist: []
            })
          }
        });

    }    

    processmanuallead(lead_id){

        
        let req = JSON.stringify({
            lead_id:lead_id
        });

        checkpushLead(req).then((response) => {
          if (response.status === 1) {
            
             $("#manualcreatlead").addClass('hidden');

             let toastr = '';
             toastr = window.toastr.success;
             toastr('', 'Lead has been created, Customer and Partner will receive lead information via email. Please reload this page', {
                 positionClass: "toast-bottom-right",
                 containerId: "toast-bottom-right"
             });    

          }
          else{
             let toastr = '';
             toastr = window.toastr.error;
             toastr('', 'Lead is not created due to some technical issue in the server', {
                 positionClass: "toast-bottom-right",
                 containerId: "toast-bottom-right"
             });  

          }
        });

    }

    confirmSend(lead_id){

        
        let req = JSON.stringify({
            lead_id:lead_id,
            mail_content:this.state.mail_content,
            partners_f:this.state.partners_f
        });

        createLeadManual(req).then((response) => {
          if (response.status === 1) {
            
            $("#mailcontent_section").hide();
            $("#manualprocesssection").hide();
            $(".returnmessage").addClass('green');
            $(".returnmessage").html("Lead has been created, Customer and Partner will receive lead information via email. Please reload this page");

          }
          else{
            $(".returnmessage").addClass('red');
            $(".returnmessage").html("sorry..some technical issue");

          }
        });

      }


    async partnerLeadInfo(lead_id) {


        let req = JSON.stringify({
            lead_id: lead_id
        });

        getPartnerLeadInfo(req).then((response) => {
          if (response.status === 1) {
            this.setState({
                partnerlist: response.list
            })
          }else{
            this.setState({
                partnerlist: []
            })
          }
        });

    }

    async leadDetail(lead_id) {

          let response = await FetchCall.getLeadDetail(lead_id);
          if (response.status === 1) {

            this.setState({
                    lead_id: response.detail.id,
                    lead_number:response.detail.lead_number,
                    firstname: response.detail.firstname,
                    lead_status: response.detail.lead_status,
                    city: response.detail.city,
                    lastname: response.detail.lastname,
                    email:response.detail.email,
                    grades:response.detail.grades,
                    subcategory:response.detail.subcategory,
                    subcategory_text:response.detail.subcategory_text,
                    mobilenumber:response.detail.mobilenumber,
                    created_date: new Intl.DateTimeFormat('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(response.detail.created_date),
                    lead_data: response.detail.lead_data ? JSON.parse(response.detail.lead_data) : [],
                    location: response.detail.location,
                    city:response.detail.city,
                    lead_vertical: response.detail.lead_vertical,
                    accepttakingcalls:response.detail.accepttakingcalls,
                    searchkey: response.detail.searchkey,
                    user_id:response.detail.user_id
            })

            if(response.detail.searchkey){
                    let cat_detail = await FetchCall.getCategoryDetail(response.detail.searchkey);

                    if (cat_detail.status === 1) {

                        this.setState({subvertical:cat_detail.results[0].category_name});

                        let subcategory = await FetchCall.getCategoryDetail(response.detail.subcategory);
                        if (subcategory.status === 1) {
                            this.setState({subcategory_text:subcategory.results[0].category_name});
                        }

                    }
                
            }

          }


    }
           

    renderUsers() {
          const userList = [];
  
                for(let i = 0; i < this.state.partnerlist.length; i++) {
                    
                          userList.push(<tr class="table-info">
                                          <td><a href={(this.state.partnerlist[i].partner_link==null)?"#":"https://bewise.in"+this.state.partnerlist[i].partner_link} target="_blank">{this.state.partnerlist[i].partner_name}</a></td>
                                          { /* <td> {this.state.partnerlist[i].user_type==1?"Institute":"Individual"}</td> */ }
                                          <td> {this.state.partnerlist[i].seen==1?"Yes":"No"}</td>
                                          <td>{this.state.partnerlist[i].seen_mobilenumber==1?"Yes":"No"}</td>
                                          <td> {this.state.partnerlist[i].seen_emailid==1?"Yes":"No"}</td>
                                      </tr>);
                }
    
          return userList;
    }     
        
    handleEditorChange(value, editor) {
      this.setState({
        mail_content: value
      });
    }

    componentDidMount() {

        let user_data = localStorage.getItem("user_data");
        let auth_data = JSON.parse(user_data);
        let vendor_id = auth_data.login_id;
        let role = auth_data.role;
        this.setState({ vendor_id: vendor_id, role:role });
       
    }

    componentDidUpdate() {
       // window.jQuery('.selectpicker').selectpicker('refresh')
    }

    handleSubmit = (e) => {

 
    };

    render() {

         const {lead_id, lead_number, lead_status, 
                email, 
                mobilenumber, 
                lead_data, 
                firstname, 
                lastname, 
                lead_vertical, 
                grades,
                searchkey, 
                subcategory_text,
                subvertical,
                subcategory,
                location, 
                city, 
                accepttakingcalls, 
                created_date, 
                partnerlist,
                manualpartnerlist,
                user_id} = this.state;


        return (
            <React.Fragment>
                <AdminLayout>
                    
           <div class="col-lg-12 grid-margin stretch-card">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title">Leads </h4>

                    <a href="/leads/leadlist" class="btn btn-sm btn-primary">Back to list</a>
                 
                    <div class="leadpage">

  <div class="d-flex justify-content-between align-items-center py-3">
    <h2 class="h5 mb-0"><a href="#" class="text-muted"></a> Lead Ref# :{lead_number}</h2>
  </div>


  <div class="row">
    <div class="col-lg-8">
 
      <div class="card mb-4">
        <div class="card-body">
          <div class="mb-3 d-flex justify-content-between">
            <div>
              <span class="me-3">Created Date: {created_date}&nbsp;</span>
             
            </div>
            <div class="d-flex">
              
              <div class="exportbox">
                <ul class="dropdown-menu dropdown-menu-end">
                 
                  <li><a class="dropdown-item" href="#"><i class="bi bi-printer"></i> Print</a></li>
                </ul>
              </div>
            </div>
          </div>
          <table class="table table-borderless">
            <tbody>
              <tr>
                <td>

                    <div>
                    <label>Vertical</label>
                    <div>{lead_vertical}</div><br/>
                    </div>
                    
                    {searchkey!=null && 
 
                        <div>
                            <label>Category</label>
                            <div>{subvertical}</div><br/>
                        </div>

                    }

                    {subcategory!=null && 
 
                        <div>
                            <label>Subcategory</label>
                            <div>{subcategory_text}</div><br/>
                        </div>

                    }
                    
                    
                    <div>
                    <label>City</label>
                    <div>{city}</div>
                    </div>
                    <br/>
                     <div>
                    <label>Locality</label>
                    <div>{location}</div>
                    </div>
                    <br/>
                    <div>
                    <label>Opt for Calling</label>
                    {accepttakingcalls=='listing' &&
                        <div>Opt not for receiving calls</div>
                    }

                    {accepttakingcalls=='no' &&
                         <div>Opt not for receiving calls</div>
                    }
                    </div>
                    <br/>
                    <div>
                    <label>Other Vertical Attributes chosen</label>
                    <div class="borderbox">
                        {lead_vertical=='tuitions' && 
                        <ul>
                            <li>Grade: <b>{grades}</b></li>
                            <li>Board of Education: <b>{lead_data.lead_board}</b></li>
                            <li>Learning Location: <b>{lead_data.lead_mode}</b></li>
                            <li>User prefers to work with: <b>{lead_data.lead_premisestype}</b></li>
                        </ul>
                        }

                      
                        {lead_vertical=='school' && 
                        <ul>
                            <li>Grade: <b>{lead_data.lead_grades}</b></li>
                            <li>Board of Study: <b>{lead_data.lead_board}</b></li>
                            <li>Learning Location: <b>{lead_data.lead_mode}</b></li>
                            <li>User prefers to work with: <b>{lead_data.lead_premisestype}</b></li>
                        </ul>
                        }
                        {lead_vertical=='schools' && 
                        <ul>
                            <li>Grade: <b>{lead_data.lead_grades}</b></li>
                            <li>Board of Study: <b>{lead_data.lead_board}</b></li>
                            <li>Learning Location: <b>{lead_data.lead_mode}</b></li>
                            <li>User prefers to work with: <b>{lead_data.lead_premisestype}</b></li>
                        </ul>
                        }
                        {lead_vertical=='preschools' && 
                        <div>No information</div>
                        }
                        {lead_vertical=='music' && 
                        <ul>
                            <li>Learning Location: <b>{lead_data.lead_mode}</b></li>
                            <li>User prefers to work with: <b>{lead_data.lead_premisestype}</b></li>
                        </ul>
                        }
                        {lead_vertical=='sports' && 
                        <ul>
                            <li>Learning Location: <b>{lead_data.lead_mode}</b></li>
                            <li>User prefers to work with: <b>{lead_data.lead_premisestype}</b></li>
                        </ul>
                        }

                        {lead_vertical=='dance' && 
                        <ul>
                            <li>Dance Type: <b>{lead_data.lead_sporttype}</b></li>
                            <li>Learning Location: <b>{lead_data.lead_mode}</b></li>
                            <li>User prefers to work with: <b>{lead_data.lead_premisestype}</b></li>
                        </ul>
                        }
                        {lead_vertical=='creativearts' && 
                        <ul>
                            <li>Learning Location: <b>{lead_data.lead_mode}</b></li>
                            <li>User prefers to work with: <b>{lead_data.lead_premisestype}</b></li>
                        </ul>
                        }
                        {lead_vertical=='hobbies' && 
                        <ul>
                            <li>Learning Location: <b>{lead_data.lead_mode}</b></li>
                            <li>User prefers to work with: <b>{lead_data.lead_premisestype}</b></li>
                        </ul>
                        } 
                        {lead_vertical=='mindandskills' && 
                        <ul>
                            <li>Learning Location: <b>{lead_data.lead_mode}</b></li>
                            <li>User prefers to work with: <b>{lead_data.lead_premisestype}</b></li>
                        </ul>
                        }                       
                    </div>
                    </div>
                </td>
                
              </tr>

              
            </tbody>
             
          </table>
          {this.state.role==1 &&                            
          <div>
                <label>Partners Details</label>
                <div class="container-fluid">
                    
                        <div>

                        {this.state.partnerlist.length>0 && (                      

                                <table class='table table-striped table-sm'>
                                <tr class="table-success">
                                    <th scope='col'>Partner</th>
                                     
                                    <th scope='col'>Lead seen</th>
                                    <th scope='col'>Mobile no seen</th>
                                    <th scope='col'>Email Id seen</th>
                                </tr>
                        
                                {this.renderUsers()}

                                </table>
                        )}

                        {this.state.partnerlist.length==0 && (
                                <div id="manualcreatlead">As there may be an issue processing the lead in the server or in algorithm, Please click below to see and send regret mail with partners</div>
                        
                        )}
                        <br/>
                        {this.state.partnerlist.length==0 && (
                                <div id="manualcreatleadoption">
                                <p>Select distance you want to fetch</p>
                                <select name="distance" onChange={this.handleChange}>
                                    <option value="">Auto</option>
                                    <option value="15">15</option>
                                    <option value="20">20</option>
                                    <option value="25">25</option>
                                    <option value="30">30</option>
                                </select>

                                <p>Select type/mode you want to fetch from</p>
                                <select name="modetype" onChange={this.handleChange}>
                                  <option value="">Auto</option>
                                  <option value="online">Online</option>
                                  <option value="premises">Premises</option>
                                  <option value="home">Home</option>
                                </select>
                                </div>

                                
                        
                        )}
                        <br/>
                        {this.state.role==1 && this.state.partnerlist.length==0 && (
                                <div id="manualbtnsection"><button class='btn btn-primary btn-sm processpush' onClick={()=>this.domanualprocess(this.lead_id)}>Check if any partners found within the range of distance</button></div>
                        )}
                         <br/>
                         <br/>
                        </div>
                        <div class="responsemessage" id="responsemessage"></div>  
                        <br/>
                        <br/> 

                    {accepttakingcalls=='listing' && (      
                        <div>This user chosen option to directly call the tutors/coach/teachers suggested by BeWise</div>
                    )}

                </div>
          </div>
          }



          {this.state.role==1 && !this.state.openModal &&            
          <div id="manualbtnsection"><button class='btn btn-primary btn-sm processpush' onClick={()=>this.domanualprocess(this.lead_id)}>Manual process to check Mail content</button></div>
          }

          {this.state.role==1 && !this.state.openModal &&            
          <div id="manualbtnsection"><button class='btn btn-primary btn-sm processpush' onClick={()=>this.doregretprocess(this.lead_id)}>No Data - Send Regret Mail</button></div>
          }


         {this.state.role==1 && this.state.openModal &&              
          <div class="manualprocesssection" id="manualprocesssection">

              <div class="partnerlist">

                  {manualpartnerlist.length>0 && (                      

                      <table class='table table-striped table-sm'>
                      <tr class="table-success">
                        <th scope='col'>Partner Name</th>
                        <th scope='col'>City</th>
                        <th scope='col'>Address</th>
                      </tr>
                      { manualpartnerlist.map((partner, i) => {   

                       return <tr class="table-info">
                                        <td><a href={(partner.partner_link==null)?"#":"https://bewise.in"+partner.partner_link} target="_blank">{partner.partner_name}</a></td>
                                        <td>{partner.partner_city}</td>
                                        <td>{partner.partner_address}</td>
                        </tr>

                       })
                      }
                      </table>
                  )}

              </div>       
               
              <div class="row" id="submittoconfirm">
                <div class="col-md-12">
                <button class='btn btn-primary btn-sm' onClick={this.confirmPush}>I confirm and send an email to the customer</button>
                </div>
              </div>
                 

          </div>  
          }                    

         

          {this.state.loading &&

            <div>loading please wait.....</div>

          }

        {!this.state.loading && this.state.confirmnodataregret &&             
          <div class="regret_mailcontent_section" id="regret_mailcontent_section">

              <div class="partnerlist">
                        <Editor
                            onEditorChange={this.handleEditorChange}
                            toolbar={{
                                inline: { inDropdown: true },
                                list: { inDropdown: true },
                                textAlign: { inDropdown: true },
                                link: { inDropdown: true },
                                history: { inDropdown: true },
                                image: { uploadCallback: this.uploadImageCallBack, alt: { present: true, mandatory: true } },
                              }}
                            value={this.state.regret_mailcontent}
                            name="regret_mailcontent"
                            apiKey={TINY_EDITOR}
                            init={{
                                  height: 300,
                                  theme:"silver",
                                  plugins: ["advlist autolink lists link anchor paste image"],
                                  toolbar: 'undo redo | formatselect | image| bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | help'
                                
                            }}
                   
                          />
                
              </div>       

              <div id="submittosend" class="row">
                <div class="col-md-12">
                  <button class='btn btn-primary btn-sm' onClick={()=>this.confirmRegretSend(this.lead_id)}>Send</button>
                </div>
              </div>
                 

          </div>                      

          }


          {!this.state.loading && this.state.checkMailContent &&             
          <div class="mailcontent_section" id="mailcontent_section">

              <div class="partnerlist">
                        <Editor
                            onEditorChange={this.handleEditorChange}
                            toolbar={{
                                inline: { inDropdown: true },
                                list: { inDropdown: true },
                                textAlign: { inDropdown: true },
                                link: { inDropdown: true },
                                history: { inDropdown: true },
                                image: { uploadCallback: this.uploadImageCallBack, alt: { present: true, mandatory: true } },
                              }}
                            value={this.state.mail_content}
                            name="mail_content"
                            apiKey={TINY_EDITOR}
                            init={{
                                  height: 300,
                                  theme:"silver",
                                  plugins: ["advlist autolink lists link anchor paste image"],
                                  toolbar: 'undo redo | formatselect | image| bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | help'
                                
                            }}
                   
                          />
                
              </div>       

              <div id="submittosend" class="row">
                <div class="col-md-12">
                  <button class='btn btn-primary btn-sm' onClick={()=>this.confirmSend(this.lead_id)}>Send</button>
                </div>
              </div>
                 

          </div>                      

          }
            <div class="returnmessage" id="returnmessage"></div>
        </div>
      </div>
     

    </div>
    <div class="col-lg-4">

      <div class="card mb-4">
        <div class="card-body">
          <div class="card-header"> <span class="me-3">Customer Info</span></div>
          <div><strong>{firstname} {lastname}</strong><br/></div>
          {accepttakingcalls=='call' &&  
          <div>
            <div class="btnaction">Email: {email==''?'none':email}</div>
            <div class="btnaction">Phone : {mobilenumber==''?'none':mobilenumber}</div>
            <div class="btnaction">BeWise User ID : {user_id==0?'Not Defined':user_id} {user_id==0 && <button class="btn btn-primary btn-sm" o>Create User</button> }</div>
          </div>
        }
        </div>
      </div>
      {this.state.role==1 &&
      <div class="card mb-4">
        <div class="card-body">
          <div class="card-header"> <span class="me-3">Mail Info</span></div>
          <div class="row">
         
          {this.state.maillist.length>0 && 
            <div class="mailinfo">
              { this.state.maillist.map((maillog, idx) => ( 
                  <div>{maillog.subject} - {maillog.to} - <b>{(maillog.info=='success')?"Success":"Invalid EmailId"}</b> </div>
              ))}
            </div>
          }
          </div>
          <button class="btn btn-primary btn-sm" id="showmailinfoBtn" onClick={this.getMailinfo}>Click to view</button>
        </div>
      </div>
      }

    </div>
  </div>
</div>
 
                </div>
              </div>
            </div>

                </AdminLayout>
            </React.Fragment>
        )
    }
}


export default leadDetail;


// WEBPACK FOOTER //
// ./src/components/bewise/leadDetail.jsx